<template>

    <div
        class="video-item flex flex-col mb-3 rounded-none sm:rounded-2xl shadow-md border-0 border-birdie-grey-light overflow-hidden relative z-10">

        <div v-if="selectMode" class="absolute inset-0 w-full h-full bg-gray-900 bg-opacity-30 z-[60]">
        </div>

        <a :href="'/library/' + video.uuid" target="_blank" title="Open in new tab"
            class="video-box relative overflow-hidden pb-16/9 mx sm:rounded-t-2xl">

            <!-- 			<video-player
                ref="videoPlayer"
                v-show="isActiveOne"
				v-if="video.grantaccess && !is_processing"
				class="vjs-custom-skin"
				:options="playerOptions"
                :is_list="true"
				@play="onPlayerPlay($event)"
				@playing="onPlayerPlaying($event)"
				@ready="onPlayerReady($event)"
				@pause="onPlayerPause($event)"
				@ended="onPlayerEnd($event)">
		    </video-player> -->



            <div v-if="!video.grantaccess" class="absolute w-full pb-16/9 img blur"
                :style="'background-image:url(' + fullPathFor(video.image_thumb) + ');filter:blur(3px);'"></div>

            <div v-if="state == 'ready'" class="absolute w-full pb-16/9 img thumb"
                :style="'background-image:url(' + fullPathFor(video.image_thumb) + ')'"></div>

            <div v-if="is_processing" class="absolute w-full pb-16/9 img thumb"></div>

            <div v-if="state == 'ready' && video.image_gif" class="absolute w-full pb-16/9 img gif"
                :style="'background-image:url(' + fullPathFor(video.image_gif) + ')'">
                <div class="gif-overlay"></div>
            </div>

            <div v-if="!video.grantaccess" class="absolute w-full pb-16/9 gif" style="background: none">
                <div class="gif-overlay"></div>
            </div>

            <div v-if="video.grantaccess && !deleting && !is_processing && !waiting_delete && !selectMode"
                class="absolute w-full h-full top-0 left-0 flex group justify-end items-start">


                <div
                    class="bg-black opacity-0 group-hover:opacity-50 transition-opacity absolute w-full h-full top-0 left-0 z-0 sm:rounded-t-xl">
                </div>

                <div v-if="state == 'ready'" class="play mx-auto my-auto " ref="videoButtonPlay"></div>

                <div class="opacity-0 flex flex-col gap-y-3 group-hover:opacity-100 transition-opacity mt-3 mr-3 z-10 ">

                    <a class="flex bg-white rounded-full h-7 w-7 shadow-md items-center justify-center cursor-pointer hover:bg-birdie-blue hover:text-white"
                        :href="'/library/' + video.uuid" title="Open video in a new tab" target="_blank">
                        <ArrowTopRightOnSquareIcon class="h-4 w-4" />
                    </a>

                    <a href="#"
                        class="bg-white rounded-full h-7 w-7 shadow-md flex items-center justify-center cursor-pointer hover:bg-birdie-blue hover:text-white"
                        @click.prevent.stop="action_link()" title="Copy Share link"
                        v-clipboard:copy="video.sharing_link">
                        <LinkIcon class="h-4 w-4" />
                    </a>

                    <a href="#"
                        class="bg-white rounded-full h-7 w-7 shadow-md flex items-center justify-center cursor-pointer hover:bg-birdie-blue hover:text-white"
                        title="Delete this video" @click.prevent.stop="action_delete()">
                        <TrashIcon class="h-4 w-4" />
                    </a>

                </div>

            </div>


            <div v-else-if="!video.grantaccess" class="play locked mx-auto my-auto" ref="videoButtonPlay"></div>

            <div class="bg-black rounded-full absolute right-3 bottom-3 text-white font-bold text-xs py-1 px-3"
                v-html="getDuration(video.video_length)"></div>

            <transition name="fade">
                <div class="flex text-sm justify-center items-center embed-responsive-item overlay copy font-bold"
                    v-if="copied">
                    Link Copied!
                </div>
            </transition>


            <transition name="fade">
                <div class="flex flex-col justify-center overlay delete text-sm" v-if="deleting || waiting_delete"
                    @click.prevent.stop="action_delete_cancel()">
                    <div class="absolute w-10 h-10 top-0 right-0 text-center flex flex-col justify-center items-center"
                        v-if="deleting">
                        <vue-feather type="x" class="h-5 w-5"></vue-feather>
                    </div>
                    <div class="text-center font-bold" v-if="deleting">
                        <p>⚠️<br />This can't be undone</p>
                        <jet-danger-button class="mt-4" @click.prevent.stop="action_delete_confirm()">
                            Confirm Delete
                        </jet-danger-button>
                    </div>
                    <div class="text-center font-bold" v-else-if="waiting_delete">
                        <spinner class="mx-auto h-5 w-5 text-white mb-4"></spinner>
                        <p>Deleting…</p>
                    </div>
                </div>
            </transition>


            <!-- <transition name="fade">
  			<div class="flex flex-col justify-center overlay download" v-if="waiting_download">
  				<div class="text-center">
  					Wait a few seconds, <br />
  					<spinner class="mx-auto h-5 w-5 text-white my-4"></spinner>
                    <br />
  					download is starting…
  				</div>
  			</div>
			</transition> -->

            <transition name="fade">
                <div class="flex flex-col justify-center overlay download" v-if="is_processing">
                    <div class="text-center font-normal text-sm" v-if="!transcoding_error">
                        <spinner class="mx-auto h-5 w-5 text-white mb-4"></spinner>
                        processing new video…
                    </div>
                    <div class="text-center font-normal text-sm" v-else>
                        ⚠️<br />
                        There was a processing error,<br />this video will be unavailable…
                    </div>
                </div>
            </transition>




        </a>

        <div class="bg-white pb-2 sm:rounded-b-2xl">








            <div class="video-details title " v-if="video.grantaccess">

                <div class="flex flex-row">



                    <div class="flex-grow title">
                        <input type="text"
                            class="form-control form_line thin blank mt-0 block w-full px-0.5 border-0 border-b-2 border-gray-200 focus:ring-0 focus:border-black text-sm truncate pr-4"
                            :value="video.title" :placeholder="placeholderTitle" debounce="500"
                            @change="titleChange($event)" @focus="editing_title = true" @blur="editing_title = false" />
                    </div>

                    <div v-if="video.sent && false"
                        class="flex h-6 w-6 ml-2 mr-2 mt-2 items-center justify-center rounded-full bg-gray-200 relative text-sm"
                        v-tippy="{ content: video.secure_sharing ? 'Secure Sharing is enabled' : 'Secure Sharing is disabled' }">
                        <LockClosedIcon v-if="video.secure_sharing" class="h-4 w-4 text-gray-700" />
                        <LockOpenIcon v-else class="h-3 w-3 text-gray-400" />
                        <CheckCircleIcon v-if="video.secure_sharing"
                            class="w-3 h-3 text-green-400 absolute bottom-0 right-0 bg-gray-200 rounded-full" />
                    </div>

                </div>
            </div>
            <div class="video-details title " v-else>
                <div class="flex flex-row">
                    <div class="text-blue-500 text-3xl leading-8 w-4 mr-3">•</div>
                    <!-- <div class="emojiBox icon d-flex align-items-center justify-content-center">
                        <emoji v-if="video.emoji" :data="emojiIndex" :native="isApple" :emoji="video.emoji" :size="25" />
                    </div> -->
                    <div class="flex-grow title">
                        <div class="form-control w-full px-0.5 pt-2 text-sm">{{ placeholderTitle }}</div>
                    </div>
                </div>
            </div>





            <div class="video-details contact">
                <div class="flex items-center text-birdie-dark">
                    <UserIcon v-if="geolocation.geoplugin_countryName" class="h-4 w-4 mr-2"
                        v-tippy="{ content: geolocation.geoplugin_city + ', ' + geolocation.geoplugin_countryName }">
                    </UserIcon>
                    <UserIcon v-else-if="geolocation.country" class="h-4 w-4 mr-2"
                        v-tippy="{ content: geolocation.country + ', ' + geolocation.country }">
                    </UserIcon>
                    <UserIcon v-else class="h-4 w-4 mr-2">
                    </UserIcon>

                    <span class="font-medium text-sm" v-html="getContact(video)"></span>

                    <span class="flex flex-grow justify-end pr-3 text-sm">
                        <span class="" v-tippy="{ content: getReadableDate(video.created_at) }">{{
                            getDelay(video.created_at)
                            }}</span>
                    </span>
                </div>
            </div>

            <div class="video-details tags mt-0.5">
                <div class="flex flex-row">
                    <div class="flex"
                        :class="{ 'items-start': video.tags?.length > 0, 'items-center pt-1 pb-2': video.tags?.length == 0 }">
                        <TagIcon class="h-4 w-4 mr-3" :class="{ 'text-gray-400': video.tags?.length == 0 }">
                        </TagIcon>
                    </div>
                    <div class="flex flex-grow z-20">
                        <video-tags :thevideo="video" :teamtags="teamtags"></video-tags>
                    </div>
                </div>
            </div>

            <!-- <div v-if="way == 'unified_personals' && false"
                class="w-full h-5 mt-0.5 bg-gray-100 text-gray-500 -mb-2 flex items-center text-xs px-4">
                {{ whereAmI }}
            </div> -->



            <!-- <b-popover
            v-if="video.grantaccess"
                class="icon-popover"
                :target="'icon-placeholder-'+video.id"
                triggers="click blur"
                placement="auto"
                container="my-container"
                ref="popover_emoji">

                <picker :data="emojiIndex" set="apple" :native="isApple" :showSkinTones="false" title="Select Emoji" @select="selectEmoji" :emoji="video.emoji"
        :showPreview="false" />

        </b-popover> -->


        </div>

    </div>



</template>



<script>

//import {videoPlayer} from 'vue-videojs7'


//import 'emoji-mart-vue-fast/css/emoji-mart.css'
//import data from 'emoji-mart-vue-fast/data/apple.json'
//import { Picker, Emoji, EmojiIndex } from 'emoji-mart-vue-fast'
//let emojiIndex = new EmojiIndex(data)

import VideoTags from './VideoTags.vue';
//import VideoPlayer from './VideoPlayer.vue';

import moment from 'moment-timezone';

import JetDropdown from '@/Jetstream/Dropdown'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import JetDangerButton from '@/Jetstream/DangerButton'
import Spinner from '@/Components/UI/Spinner'
import { UserIcon, TagIcon } from "@heroicons/vue/20/solid";
import { LinkIcon, ArrowTopRightOnSquareIcon, TrashIcon } from "@heroicons/vue/24/outline";
import { LockClosedIcon, LockOpenIcon, CheckCircleIcon } from "@heroicons/vue/20/solid";




//import { toClipboard } from '@soerenmartius/vue3-clipboard'

export default {

    props: ['the_video', 'teamtags', 'datacenter', 'selectMode', 'way'],

    components: {
        //VideoPlayer,
        // Emoji, Picker,
        VideoTags,
        JetDropdown, JetDropdownLink, JetDangerButton,
        Spinner, UserIcon, TagIcon, LinkIcon,
        ArrowTopRightOnSquareIcon, TrashIcon,
        LockClosedIcon, LockOpenIcon, CheckCircleIcon

    },

    created: function () {
        //this.video.grantaccess = 0
        this.moment = moment;

        this.timezone = this.$page.props.tz || this.moment.tz.guess()


        this.EventBus.on("videoPlay", (video) => {
            if (this.video.id != video.id && this.state != "ready") {
                this.reset();
            }
        });

        // console.log(this.the_video)

        for (var user of this.video.users) {
            if (user.id == this.$page.props.user.id) {
                this.userViewed = true;
                break;
            }
        }
        if (this.video.user && this.video.anonymous_views > 0) {
            this.userViewed = true;
        }
        window.addEventListener('blur', (event) => {
            this.action_download_start();
        });

        if (!this.the_video.image_thumb /*|| !this.the_video.image_gif*/ || !this.the_video.video_file) {
            this.is_processing = true;
            //console.log("this.is_processing = true")
            this.check_end_processing();
        }

        if (this.the_video.source_details) {
            let source_details = JSON.parse(this.the_video.source_details);
            if (source_details.geolocation) {
                this.geolocation = source_details.geolocation;
            }
        }
    },

    beforeUnmount() {
        ///console.log('beforeUnmount');
        this.EventBus.off('videoPlay');
        if (this.endProcessingTimeout) {
            clearTimeout(this.endProcessingTimeout);
        }
    },

    data() {
        return {
            teamslug: this.$page.props.user.current_team.slug,
            s3: this.datacenter + '/videos',
            playerOptions: {
                preload: false,
                autoplay: false,
                controls: true,
                controlBar: {
                    timeDivider: false,
                    durationDisplay: true
                }
                // poster: 'https://surmon-china.github.io/vue-quill-editor/static/images/surmon-5.jpg'
            },
            state: 'ready',
            isActiveOne: false,
            //emojiIndex: emojiIndex,
            //emojiData: data,
            editing_title: false,
            video: this.the_video,
            timezone: 'utc',
            userViewed: false,
            copied: false,
            deleting: false,
            waiting_download: false,
            waiting_delete: false,
            alreadyReadCount: false,
            moment: {},
            is_processing: false,
            geolocation: {},
            transcoding_error: false,
            showingVideoDropdown: false,
            show_modal: false,
            endProcessingTimeout: null
        }
    },

    mounted: function () {
        //console.log(this.video.grantaccess, this.is_processing);

    },

    methods: {

        fullPathFor: function (filename) {
            if (!filename) {
                return '';
            }
            if (filename.startsWith('http')) {
                return filename;
            }
            return this.s3 + '/' + this.teamslug + '/' + filename;
            //return Spark.app_url + '/file/' + this.teamslug + '/' + filename;
        },
        // fullPathForBlur: function(filename) {
        //     return this.$page.props.app_url + '/fileb/' + this.teamslug + '/' + filename;
        // },
        downloadUrl: function () {
            return this.$page.props.app_url + '/download/' + this.video.uuid;
        },
        /*onPlayerPlay: function(player) {
            //console.log('player play!', player);
            this.state = 'play';
            //console.log('onPlayerPlay');
        },
        onPlayerPlaying: function(player) {
            //console.log('player play!', player);
            this.state = 'playing';
            //console.log('playing');
            if (!this.alreadyReadCount) {
                this.updateViews();
            }
        },
        onPlayerReady: function() {
            //console.log('player ready!', player)
            //player.play()
            this.state = 'ready';
            //console.log('onPlayerReady');
        },
        onPlayerPause: function(player) {
            this.state = 'paused';
            //console.log('paused');
        },
        onPlayerEnd: function(player) {
            this.state = 'ended';
            //console.log('ended');
        },
        clickVideo: function () {
            if (this.isActiveOne) {
                return
            }
            //console.log("clickVideo", this.state);
            if (!this.video.grantaccess) {
                //console.log("NO ACCESS WHAT DO I DO");
                //$('#modal-upgrade-plan').modal('show');
                this.EventBus.emit('showUpgrade',['locked_video','unlock'])
                return;
            }
            if (this.state == 'play') {
                this.reset();
                return;
            } else if (this.state == 'playing') {
                this.player.pause();
                return;
            } else if (this.state == 'paused') {
                this.player.play();
                return;
            } else if (this.state == 'ended') {
                this.player.play();
                return
            } else if (this.state == 'ready') {
                this.EventBus.emit('videoPlay', this.video);
                this.isActiveOne = true;
                const vid = {
                    withCredentials: false,
                    type: 'video/mp4',
                    src: this.fullPathFor(this.video.video_file)
                    }

                    this.player.reset() // in IE11 (mode IE10) direct usage of src() when <src> is already set, generated errors,
                    this.player.src(vid)
                    // this.player.load()
                    this.player.play()
                } else {
                    console.error('Cannot play, unknown state: ' + this.state);
                }
        },*/
        reset: function () {
            if (this.player) {
                this.player.reset();
            }
            this.state = 'ready';
            this.isActiveOne = false;
        },
        // selectEmoji: function(emoji) {
        // 	var needUpdate = emoji.id != this.video.emoji;
        // 	this.video.emoji = emoji.id;
        // 	this.$refs.popover_emoji.$emit('close');
        // 	if (needUpdate) {
        // 		this.updateVideo();
        // 	}
        // },
        titleChange: function (event) {
            //console.log("titleChange", event.target.value)
            let new_title = event.target.value
            var needUpdate = new_title != this.video.title;
            this.video.title = new_title;
            if (needUpdate) {
                this.updateVideo();
            }
        },
        check_end_processing: function () {
            let url = this.$page.props.api_url + '/v1/video/' + this.video.id;
            var params = {};
            axios.post(url, params)
                .then(response => {
                    // console.log(response.data);
                    if (response.data) {
                        if (response.data.image_thumb /*&& response.data.image_gif*/ && response.data.video_file) {
                            this.video = response.data;
                            this.is_processing = false;
                            return;
                        } else if (response.data.metadata) {
                            let metadata = JSON.parse(response.data.metadata);
                            if (metadata.transcoding) {
                                if (metadata.transcoding == "error") {
                                    this.transcoding_error = true;
                                    return;
                                }
                            }
                        }
                    }
                    this.endProcessingTimeout = setTimeout(function () {
                        this.check_end_processing();
                    }.bind(this), 2000);
                })
                .catch(e => {
                    console.log(e);
                });
        },
        updateVideo: function () {
            let url = this.$page.props.api_url + '/v1/video/' + this.video.id;
            var params = {
                title: this.video.title,
                //emoji: this.video.emoji
            };
            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                })
                .catch(e => {
                    console.log(e);
                });
        },
        // updateViews: function () {
        //     if (this.alreadyReadCount || this.video.user) {
        //         return;
        //     }
        //     let url = this.$page.props.api_url + '/v1/video/views/' + this.video.id;
        //     var params = {};
        //     axios.post(url, params)
        //         .then(response => {
        //             //console.log(response.data);
        //             this.userViewed = true;
        //             this.alreadyReadCount = true;
        //         })
        //         .catch(e => {
        //             console.log(e);
        //         });
        // },
        getReadableDate: function (date) {
            let mom = this.moment(date).tz(this.timezone);
            return mom.format("ddd MMM Do YYYY, HH:mm:ss");
        },
        getFileDateAsName: function (date) {
            let mom = this.moment(date).tz(this.timezone);
            return mom.format("MMMM DD, YYYY") + ' - ' + this.$page.props.app_name + ' Feedback.mp4';
        },
        getPlaceholderTitle: function () {
            let mom = this.moment(this.video.created_at).tz(this.timezone);
            return mom.format("MMMM DD, YYYY");
        },
        getDelay: function (date) {
            return this.moment.utc(date).fromNow();
        },
        getDuration: function (millisec) {
            var time = Math.round(millisec / 1000);
            var minutes = Math.floor(time / 60);
            var seconds = time - minutes * 60;

            if (seconds < 10) {
                seconds = '0' + String(seconds);
            }
            return String(minutes) + ':' + String(seconds);
        },
        getContact: function (video) {

            if (video.user) {
                return video.user.name;
            }

            if (!video.contact) {
                return 'anonymous user';
            }

            let intercomLink = this.hasIntercomLink(video.contact);

            if (video.contact.anonymous == 1) {
                return 'anonymous user';
            }
            if (!video.grantaccess) {
                return 'identified user';
            }

            if (video.contact.details) {
                let details = JSON.parse(video.contact.details);
                if (!video.contact.name && details.name) {
                    video.contact.name = details.name;
                }
                if (!video.contact.email && details.email) {
                    video.contact.email = details.email;
                }
            }


            if (video.contact.name) {
                if (intercomLink) {
                    return '<a href="' + intercomLink + '" target="_blank">' + video.contact.name + '</a>';
                } else if (video.contact.email) {
                    return '<a href="mailto:' + video.contact.email + '">' + video.contact.name + '</a>';
                }
                return video.contact.name;
            }
            if (video.contact.email) {
                if (intercomLink) {
                    return '<a href="' + intercomLink + '" target="_blank">' + video.contact.email + '</a>';
                } else if (video.contact.email) {
                    return '<a href="mailto:' + video.contact.email + '">' + video.contact.email + '</a>';
                }
            }
            if (video.contact.identifier) {
                if (video.contact.details) {
                    let details = JSON.parse(video.contact.details);
                    if (details.role && details.external_id) {
                        if (details.external_id == video.contact.identifier) {
                            if (intercomLink) {
                                return '<a href="' + intercomLink + '" target="_blank">Intercom ' + details.role + '</a>';
                            } else {
                                return "Intercom " + details.role;
                            }
                        }
                    }
                }
                return 'user id ' + video.contact.identifier;
            }
        },
        hasIntercomLink: function (contact) {
            if (contact.details) {
                let details = JSON.parse(contact.details);
                if (details.workspace_id && details.id) {
                    return "https://app.intercom.com/a/apps/" + details.workspace_id + "/users/" + details.id;
                }
            }
            return false;
        },
        dropdown: function () {
            this.$refs.dropdown_toggle.dropdown();
        },
        action_link: function () {
            //let link = this.$page.props.app_url + '/share/' + this.video.uuid;
            //this.$copyText(link);
            //this.$eventBus.$emit('toast', 'Link Copied!');
            this.copied = true;
            // this.$refs.menu.close()
            let timeout_message = setTimeout(function () {
                this.copied = false;
            }.bind(this), 1000);

        },
        action_delete: function () {
            this.deleting = true
        },
        action_delete_confirm: function () {
            if (this.deleting == true) {
                this.waiting_delete = true;
                this.deleting = false;
                let url = this.$page.props.api_url + '/v1/video/' + this.video.id + '/delete';
                var params = {};
                axios.post(url, params)
                    .then(response => {
                        this.waiting_delete = false;
                        this.$parent.removeVideos([this.video.id]);
                    })
                    .catch(e => {
                        console.log(e);
                    });
            }
        },
        action_delete_cancel: function () {
            this.deleting = false;
        },
        action_download_wait: function () {
            this.waiting_download = true;
            let timeout_message = setTimeout(function () {
                this.waiting_download = false; // auto hide after 3 seconds
            }.bind(this), 3000);
        },
        action_download_start: function () {
            this.waiting_download = false;
        }
    },

    computed: {
        // whereAmI() {
        //     let where = "In: "
        //     if (this.the_video.mine) {
        //         where += "Personal"
        //     } else {
        //         where += "Team"
        //     }
        //     if (this.the_video.folder) {
        //         where += " / " + this.the_video.folder.name
        //     }
        //     return where
        // },
        player() {
            if (this.$refs.videoPlayer) {
                return this.$refs.videoPlayer.player
            }
            return false
        },
        isApple: function () {
            return navigator.platform.indexOf("Mac") != -1 || navigator.platform.indexOf("iPhone") != -1;
        },
        placeholderTitle: function () {
            let mom = this.moment(this.video.created_at).tz(this.timezone);
            if (mom) {
                return mom.format("MMMM DD, YYYY");
            }
            let mom2 = this.moment(this.video.created_at);
            if (mom2) {
                return mom2.format("MMMM DD, YYYY");
            }
            return "No title…"
        }
    }
}

</script>

<style scoped scss>
/***********************************/
/******     VIDEO ITEMS     ********/
/***********************************/


.video-item {
    position: relative;
}

.video-item .video-box {
    display: block;
    position: relative;
    background-color: #000;
    /* border-radius: 4px; */
    overflow: hidden;
}

.video-item .video-box .img {
    position: absolute;
    top: 0;
    left: 0;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    width: 100%;
    height: 100%;
}

.video-item .video-box .img.gif {
    opacity: 0;
    -moz-transition: opacity 0.2s ease-out;
    -webkit-transition: opacity 0.2s ease-out;
    transition: opacity 0.2s ease-out;
}

.video-item .video-box:hover .img.gif {
    opacity: 1;
}

.video-item .video-box .img.gif .gif-overlay {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
}

.video-item .video-box .overlay {
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.77);
    color: #FFF;
    width: 100%;
    height: 100%;
}

.video-item .video-box a.closeIcon {
    display: block;
    position: absolute;
    top: 5px;
    right: 5px;
    width: 23px;
    height: 23px;
    /* color: $gray-300; */
}

.video-item .video-box a.closeIcon:hover {
    color: #FFF;
}

.video-item .video-box-menu {
    position: absolute;
    top: 0;
    right: 2px;
}

.video-box-menu .btn {
    padding: 2px 4px;
    margin: 0;
    border: 0;
    background: none;
    color: rgba(255, 255, 255, 0.6);
}

.video-box-menu .btn:hover {
    background: none;
    color: rgba(255, 255, 255, 1);
}

.video-box-menu .btn:active,
.video-box-menu .btn-secondary:active,
.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show>.btn-secondary.dropdown-toggle {
    background: none;
    color: rgba(255, 255, 255, 1);
}

.video-item .locked-icon {
    /* color: $gray-800; */
    position: absolute;
    top: 9px;
    right: 9px;
    width: 30px;
    height: 30px;
    opacity: 0.5;
    background: #FFF;
    border-radius: 99px;
    text-align: center;
}


.video-item .video-box .play {
    position: absolute;
    width: 70px;
    height: 70px;
    background: url(/img/play-circle.svg) no-repeat center center;
    opacity: 0.5;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    -moz-transition: opacity 0.2s, width 0.2s, height 0.2s;
    -webkit-transition: opacity 0.2s, width 0.2s, height 0.2s;
    transition: opacity 0.2s, width 0.2s, height 0.2s;
}

.video-item .video-box .play:hover {
    opacity: 1;
    width: 74px;
    height: 74px;
}

.video-item .video-box .play.locked {
    background: url(/img/locked-circle.svg) no-repeat center center;
}

.video-item .video-details.title {
    padding-left: 9px;
    padding-top: 1px;
    /* padding-bottom: 7px; */
}

.video-item .video-details.date {
    margin-top: -7px;
    /* color: $gray-500; */
    font-size: 0.9rem;
    padding-left: 7px;
    padding-top: 3px;
}

.video-item .video-details.contact {
    /* color: $gray-500; */
    font-size: 0.9rem;
    padding-left: 7px;
    padding-top: 3px;
}

.video-item .video-details.tags {
    /* color: $gray-500; */
    font-size: 0.9rem;
    padding-left: 9px;
    padding-top: 8px;
}

.video-item .video-details svg.icon {
    width: 16px;
    height: 16px;
    margin-top: 3px;
}

.video-item .video-details.contact svg.icon {
    margin-top: 2px;
}

.video-item .video-box-menu .dropdown-menu {
    padding: 0;
    font-size: 0.9rem;
    min-width: 0;
    margin-right: 6px;
}

.video-item .video-box-menu .dropdown-item {
    padding: 6px 27px 6px 13px;
    font-size: 0.95rem;
    border-radius: 4px;
}





.player {
    position: absolute !important;
    width: 100%;
    height: 100%;
}

.vjs-custom-skin {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.vjs-custom-skin /deep/ .video-js {
    width: 100%;
    height: 100%;
}

.vjs-custom-skin .video-js .vjs-control.vjs-progress-control {
    flex: auto !important;
}




/* .title .emojiBox {
		display: flex;
		text-align: center;
		width: 30px;
		height: 38px;
	} */

body .b-popover {
    max-width: none;
}

body .b-popover .popover-body {
    padding: 0;
}

/* body .b-popover .popover-body .emoji-mart {
		border: 0;
	} */

/*$primary-text-color: #0088FF;
	$gray-500: #9a9aac; */


.title input.form-control {
    font-size: 0.9rem;

}

.title input.form-control:focus {
    font-size: 0.9rem;
    border-bottom: 2px solid;
    color: #0088FF;
    padding-left: 1px;
    padding-bottom: 2px;
}

.form-control.form_line {
    border: none;
    background: none;
    border-bottom: 2px solid;
    border-bottom-color: rgba(255, 255, 255, 0);
    border-radius: 0;
    padding-left: 1px;
    padding-bottom: 2px;
    height: auto;
    min-height: auto;
}

.form-control.form_line:focus {
    border-bottom: 2px solid;
    border-bottom-color: #0088FF;
    padding-left: 1px;
    padding-bottom: 2px;
    height: auto;
    min-height: auto;
}

.form-control.form_line.thin {
    border-bottom: 1px solid;
    border-bottom-color: rgba(255, 255, 255, 0);
    padding-left: 1px;
    padding-bottom: 2px;
    height: auto;
    min-height: auto;
}

.form-control.form_line.thin:focus {
    border-bottom: 1px solid;
    border-bottom-color: #0088FF;
    padding-left: 1px;
    padding-bottom: 2px;
    height: auto;
    min-height: auto;
}

.form-control.form_line.blank:focus {
    border-bottom-color: rgba(255, 255, 255, 0);
    padding-left: 1px;
    padding-bottom: 2px;
    height: auto;
    min-height: auto;
}

.unread {
    display: inline-block;
    font-size: 2rem;
    line-height: 30px;
    text-decoration: none;
    margin-left: 5px;
}

.fade-enter {
    opacity: 0;
}

.fade-enter-active {
    transition: all 0.2s ease-out;
}

.fade-leave-to {
    opacity: 0;
}

.fade-leave-active {
    transition: all 0.2s ease-in;
}

svg.icon {
    width: 18px;
    height: 18px;
}

.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show>.btn-secondary.dropdown-toggle {
    background: none;
    border: 0;
}

.title div.blank {
    opacity: 0.5;
    font-size: 1.1rem;
}

.video-box-menu .dropdown-item svg {
    width: 16px;
    height: 16px;
    padding-bottom: 3px;
}

.burgermenu {
    width: 21px;
    height: 21px;
    margin: 0 auto;
    padding: 0;
}
</style>

<style>
.vjs-custom-skin .vjs-paused .vjs-big-play-button {
    display: none !important;
}
</style>
